export default "__VITE_ASSET__DZZkiN1K__"